import React from "react";

const HomePress = () => {
  return (
    <section className="press-container">
      <div className="press-title">As featured on</div>
      <div className="logos-container">
        <div className="logos-row left">
          <a href="http://businessinsider.com/personal-finance/personal-loans/fig-personal-loans-review"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-logo-container">
            <img
              src="https://cdn.figloans.com/logos/featured/business_insider.svg"
              alt="Business Insider"
              className="featured-logo"
              loading="lazy"
              id="business-insider"
            />
          </a>

          <a
            href="https://www.creditkarma.com/personal-loans/i/fig-loans-review"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-logo-container">
            <img
              src="https://cdn.figloans.com/logos/featured/credit_karma.svg"
              alt="Credit Karma"
              className="featured-logo"
              loading="lazy"
              id="credit-karma"
            />
          </a>
        </div>

        <div className="logos-row right">
          <a
            href="https://www.usatoday.com/story/money/personalfinance/2017/05/22/payday-loans-dying-problem-solved-not-quite/101611192/"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-logo-container"
          >
            <img
              src="https://cdn.figloans.com/logos/featured/usa_today.svg"
              alt="USA Today"
              className="featured-logo"
              loading="lazy"
              id="usa-today"
            />
          </a>

          <a
            href="https://money.usnews.com/loans/personal-loans/reviews/fig-personal"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-logo-container">
            <img
              src="https://cdn.figloans.com/logos/featured/us_news.svg"
              alt="US News"
              className="featured-logo"
              loading="lazy"
              id="us-news"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomePress;
